import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, categoryType } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "value", label: "Total Value (USD)", two_table_header: "Total Value (USD)" },
  { value: "weight", label: "Total Weight (kg)", two_table_header: "Total Weight (kg)" },
  // { value: 'teu', label: 'Total TEU'},
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
  { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
];
export const defaultData = {
  name: "Panama Exports",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsDefault: analyticDropdownOptions[0].value,
  analyticsRangeDownloadPresent: true,
  isFilterGroupingPresent: true,
  showUiTrends: true,
  isViewAllGridNew: true,
  isShipmentGridNew: true,
  exportPDFInAnalytics: false,
  isUIGridNew: true,
  isUEGridNew: true,
  minimumDateAllowed: "2019-01-01",
  isImpExpGraph: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Shipment Value(USD)" },
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
    { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("panamaExportLatestArrivalDate"),
    getSearchResult: getApiUrl("panamaExportSearch"),
    getAnalyticsData: getApiUrl("analytics/panamaExportAnalytics"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_panama_exports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_panama_exports"),
    getShipmentByID: getApiUrl("panamaExportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfPanamaExports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/panamaExportAnalyticsViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("importerExporterGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.pa_export.country_small,
  countryCaps: globalCountryDetails.pa_export.country_caps,
  product_id: globalCountryDetails.pa_export.product_id,
  compare_product_id: globalCountryDetails.pa_export.compareProduct,
  country_CamelCase: globalCountryDetails.pa_export.product_id,
  countryCode: globalCountryDetails.pa_export.countryCode,
  countryType: globalCountryDetails.pa_export.countryType,
  manyCountryType: globalCountryDetails.pa_export.manyCountryType,
  countryTypeCode: globalCountryDetails.pa_export.countryTypeCode,
  redirectionID: globalCountryDetails.pa_export.redirectionID,
  analyticsCountryID: globalCountryDetails.pa_export.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Declaration Date Range",
  monthRangeHeading: "Month of Export",
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: false,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: true,
    product_hscode: true,
    exporters: true,
    importers: false,
    allCategory: true,
  },
  searchCategoryList: globalCountryDetails.pa_export.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    weight: "weight",
    teu: "teu",
    value: "shipmentValue",
    productCategory: "productCategory",
    sixDigitHsCode: "sixDigitHsCode",
    portOfLading: "standardLadingPortName",
    // portOfUnlading: "standardUnladingPortName",
  },
  filterObj: {
    countryOfDestinationRegion: "countryOfDestinationRegion",
    countryOfExportRegion: "countryOfExportRegion",
    exporterName: "exporterName",
    standardLadingPortName: "standardLadingPortName",
    customsOfficeZone: "customsOfficeZone",
    hsCode: "hsCode",
    weight: "weight",
    shipmentValue: "shipmentValue",
    derivedShipperMasterName: "derivedShipperMasterName",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
  },
  booleanFilterObj: {
    // include_master_bill: 'include_master_bill',
    exclude_blank_consignee: "exclude_blank_consignee",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  boxRangeFilterList: {
    weight: "weight",
    shipmentValue: "shipmentValue",
  },
  boxFilterObj: {
    weight: [],
    shipmentValue: [],
  },
  localisationFilterObj: {
    countryOfDestinationRegion: "countryOfDestination",
    countryOfExportRegion: "countryOfExport",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
  },
  emptyFilterObj: {
    countryOfDestinationRegion: [],
    countryOfExportRegion: [],
    exporterName: [],
    standardLadingPortName: [],
    customsOfficeZone: [],
    hsCode: [],
    weight: [],
    shipmentValue: [],
    sections: [],
    derivedShipperMasterName: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    shipperJurisdictionCountryRegion: [],
  },
  defaultBooleanFilterObj: {
    // include_master_bill: true,
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  selectAll: {
    countryOfDestinationRegion: false,
    countryOfExportRegion: false,
    exporterName: false,
    standardLadingPortName: false,
    customsOfficeZone: false,
    hsCode: false,
    weight: false,
    shipmentValue: false,
    sections: false,
    derivedShipperMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    shipperJurisdictionCountryRegion: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { heading: "Filter by Shipper Standardized Name", categoryName: categoryType.shipperDetails, eventKey: "9", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Name", categoryName: categoryType.shipperDetails, eventKey: "2", key: "exporterName", type: filterType.normalFilter, label: "Shipper Name", viewAllPlaceHolder: "Search in Shipper Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Import", categoryName: categoryType.consigneeDetails, eventKey: "1", key: "countryOfDestinationRegion", altKey: "countryOfDestination", type: filterType.localizeFilter, label: "Country of Import", viewAllPlaceHolder: "Search in Country of Import Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Export", categoryName: categoryType.shipperDetails, eventKey: "1", key: "countryOfExportRegion", altKey: "countryOfExport", type: filterType.localizeFilter, label: "Country of Export", viewAllPlaceHolder: "Search in Country of Export Filter", emptyFilterText: "", searchFilterString: "" },
    // { heading: "Filter by Port of Lading", categoryName: categoryType.ports, eventKey: "3", key: "standardLadingPortName", type: filterType.normalFilter, label: "Port of Lading", viewAllPlaceHolder: "Search in Port of Lading Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Customs Office Zone", categoryName: categoryType.ports, eventKey: "4", key: "customsOfficeZone", type: filterType.normalFilter, label: "Customs Office Zone", viewAllPlaceHolder: "Search in Customs Office Zone Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Product Category", categoryName: categoryType.cargoDetails, eventKey: "5", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: categoryType.cargoDetails, eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: categoryType.cargoDetails, eventKey: "5", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Search in HS Code Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Gross Weight (kg)", categoryName: categoryType.cargoDetails, eventKey: "6", key: "weight", type: filterType.boxFilter, label: "Gross Weight (kg)", viewAllPlaceHolder: "Gross Weight (kg)", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipment Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "7", key: "shipmentValue", type: filterType.boxFilter, label: "Shipment Value (USD)", viewAllPlaceHolder: "Shipment Value (USD)", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: categoryType.cargoDetails, eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    {
      heading: "Filter by Shipper Jurisdiction Country",
      categoryName: "shipperDetails",
      eventKey: "25",
      key: "shipperJurisdictionCountryRegion",
      altKey: "shipperJurisdictionCountry",
      type: "localization-filter",
      label: "Shipper Jurisdiction Country",
      viewAllPlaceHolder: "Search Shipper Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: true, key: "uniqueImportExporterWeight" },
    { isVisible: false, key: "uniqueImportExporterTeu" },
    { isVisible: true, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [
    { key: "ruc_number", label: "Shipper RUC Number" },
    { key: "exporter_name", label: "Shipper Name" },
    { key: "derived_shipper_master_name", label: "Shipper Standardized Name" },
    { key: "hs_code", label: "HS Code" },
    { key: "product_description", label: "Product Description (Spanish)" },
    { key: "derived_product_description_english", label: "Product Description" },
    { key: "derived_shipper_parent_company_name", label: "Shipper Parent Company" },
    { key: "derived_consignee_parent_company_name", label: "Consignee Parent Company" },
  ],
  shipmentSorting: [
    { columnKey: "declaration_date", value: "date", isDefault: true },
    { columnKey: "gross_weight_kgs", value: "weight", isDefault: false },
    { columnKey: "fob_value", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
  ],
  importerSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
  ],
  sortKeyMap: {
    date: "declaration_date",
    weight: "gross_weight_kgs",
    shipment_value: "fob_value",
  },
  sortKeyUniqueImpExpMap: {
    shipment_value: "shipment_value",
    date: "doc_count",
    weight: "weight",
  },
  analyticsHeaderItems: [
    { label: "Total Shipments Exports", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Shipments Weight", key: "total_weight", valuePrefix: "", valueSuffix: "Kg" },
    { label: "Total Shipments Value", key: "total_value", valuePrefix: "USD", valueSuffix: "" },
  ],
  analyticsFieldsMapping: [
    { key: "trade_country_of_export_to_import", filterKey1: "countryOfExportRegion", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "trends", filterKey: "", label: "Export Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "derived_country_of_destination_name", filterKey: "countryOfDestinationRegion", label: "Countries of Import", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_customs_office_zone_name" },
    { key: "puerto", filterKey: "standardLadingPortName", label: "Ports of Lading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_destination_name" },
    { key: "derived_customs_office_zone_name", filterKey: "customsOfficeZone", label: "Customs Office Zones", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_destination_name" },
    // { key: "trade_port_destination_country", filterKey1: "standardLadingPortName", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Port of Lading -> Country of Import)", headerOne: "Port of Lading", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, showlevelTwo: true, grpType: "multi", defaultKey: "derived_shipper_master_name" },
    { key: "hs_code", headerLabel: "HS Code", filterKey: "hsCode", label: "2 digit HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "declaration_date", name: "Declaration Date", selector: "declaration_date", dataTip: "", type: "", dateFormat: "MMM DD, YYYY", sortable: true, grow: 1, wrap: true, miWidth: "140px", maWidth: "140px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 1, wrap: true, miWidth: "140px", maWidth: "140px" },
    { key: "hs_code", name: "HS Code", selector: "hs_code", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "product_description", name: "Product", selector: "product_description", tooltipValue: "product_description", type: "", grow: 1, wrap: true, isSliceEnabled: true, sliceLength: 40, miWidth: "140px", maWidth: "140px" },
    { key: "quantity", name: "Quantity", selector: "quantity", secondarySelector: "derived_unit_of_measurement_english", dataTip: "", type: "", grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
    { key: "gross_weight_kgs", name: "Gross Weight (kg)", selector: "gross_weight_kgs", dataTip: "", type: "", sortable: true, grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "110px", maWidth: "110px" },
    { key: "derived_shipper_master_name", name: "Shipper Name", selector: "derived_shipper_master_name", alternateSelector: "exporter_name", id: "derived_shipper_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E", grow: 1, wrap: true, miWidth: "140px", maWidth: "140px" },
    { key: "derived_country_of_destination_name", name: "Country of Import", selector: "derived_country_of_destination_name", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "fob_value", name: "Shipment Value (USD)", selector: "fob_value", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "120px", maWidth: "120px" },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "weight", name: "Gross Weight (kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Declaration Date", value: "declaration_date", dateFormat: true, monthFormat: false },
        { label: "HS Code", value: "hs_code" },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code" },
        { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name" },
        { label: "Shipper Name", value: "exporter_name" },
        { label: "Shipper RUC Number", value: "ruc_number" },
        { label: "Port of Lading", value: "puerto" },
        {
          label: "Shipper Jurisdiction Country",
          value: "derived_shipper_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_shipper_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [{ label: "Country of Import", value: "derived_country_of_import", countryCodeField: "derived_country_of_import_code", countryFlag: true, tooltip: true, tooltipField: "country_of_destination_code", tooltipPrefix: "Country Code: " }],
    },
    {
      id: 4,
      title: "Carrier Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [{ label: "Customs Office Zone Name", value: "derived_customs_office_zone_name", tooltip: true, tooltipField: "customs_office_code_zone", tooltipPrefix: "Customs Office Code: " }],
    },
    {
      id: 5,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "HS Code", value: "hs_code" },
        { label: "Product Description", value: "derived_product_description_english", isReadMore: true, readMoreLength: 45 },
        { label: "Product Description (Spanish)", value: "product_description", isReadMore: true, readMoreLength: 45 },
        { label: "Quantity", value: "quantity", unitField: "derived_unit_of_measurement_english", dynamicUnit: true, unitField2: "", dynamicUnit2: true, tooltip: true, tooltipField: "quantity", tooltipField2: "derived_unit_of_measurement_spanish" },
        { label: "Net Weight (kg)", value: "net_weight_kgs", valuePrefix: "", tooltip: true, tooltipField: "fob_value_colombian_peso", tooltipPrefix: "COP ", valueSuffix: " Kgs" },
        { label: "Gross Weight (kg)", value: "gross_weight_kgs", valuePrefix: "", tooltip: true, tooltipField: "derived_insurance_value_cop", tooltipPrefix: "COP ", valueSuffix: " Kgs" },
        { label: "FOB Value", value: "fob_value", valuePrefix: "USD " },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
      ],
    },
  ],
  defaultUeUiSecondLevelKey: "derived_country_of_destination_name",
  twoColumnMapping: {
    trade_country_of_export_to_import: "Trade Routes (Country of Export -> Country of Import)",
    derived_shipper_master_name: "Unique Exporters",
    derived_country_of_destination_name: "Countries of Import",
    puerto: "Ports of Lading",
    derived_customs_office_zone_name: "Customs Office Zone",
    // trade_port_destination_country: "Trade Routes (Port of Lading -> Country of Import)",

    six_digit_hs_code: "6 digit HS Codes",
  },
};

const PanamaExportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default PanamaExportSearch;
